/**
 * Background warming of Bulk Operations tab data (registered by useBulkOperations).
 */

import { getBulkLevelCache } from './bulkOperationsCache';

const LEVEL_DELAY_MS = 2800;
const WARM_SEQUENCE = ['adGroups', 'keywords', 'searchTerms', 'products'];

let warmContext = null;
let warmInFlight = null;

export function setBulkOperationsWarmContext(ctx) {
  warmContext = ctx;
}

export function clearBulkOperationsWarmContext(profileId) {
  if (!warmContext) return;
  if (!profileId || warmContext.profileId === profileId) {
    warmContext = null;
  }
}

function delay(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

/**
 * After campaigns load, fetch other tabs slowly so switching feels instant.
 */
export async function warmBulkOperationsLevelsSlowly() {
  if (!warmContext?.getFetcher) return;
  if (warmInFlight) return warmInFlight;

  const { profileId, startDate, endDate, getFetcher } = warmContext;

  warmInFlight = (async () => {
    for (const level of WARM_SEQUENCE) {
      const hit = getBulkLevelCache(profileId, startDate, endDate, level);
      if (hit?.length) {
        await delay(400);
        continue;
      }
      try {
        await getFetcher(level)();
      } catch (error) {
        console.warn(`⚠️ Bulk warm ${level}:`, error?.message || error);
      }
      await delay(LEVEL_DELAY_MS);
    }
    console.log('✅ Bulk Operations tab cache warm finished');
  })().finally(() => {
    warmInFlight = null;
  });

  return warmInFlight;
}
